import type { ComponentProps, FC, ReactNode } from 'react';
import { Button } from '@george-labs.com/design-system';

import type { Account } from '@shared/products-types';
import { t } from '@luna/i18n';
import { useActiveCustomizationFeature, useActiveProduct } from '@shared/products-core';
import { ProductColorChangeDropdown } from '@retail/products-customisation';
import { CustomizationService } from '@api-client/products';

import { useCustomizationSuccessHandler } from './hooks/useCustomizationSuccessHandler';

type Props = {
    toggle?: ReactNode;
};
export const ColorChange: FC<Props> = ({ toggle }) => {
    const { activateColorChangeCustomization } = useActiveCustomizationFeature();
    const { id, card, type } = useActiveProduct<Account>();
    const handleSuccessfulCustomization = useCustomizationSuccessHandler();

    const handleColorSave: ComponentProps<
        typeof ProductColorChangeDropdown
    >['onColorSave'] = async (color) => {
        CustomizationService.putPublicProductsCustomizationColor({
            id: card?.id || id,
            requestBody: {
                color: color.toUpperCase(),
            } as unknown as Parameters<
                typeof CustomizationService.putPublicProductsCustomizationColor
            >[0]['requestBody'],
        }).then((customization) => {
            handleSuccessfulCustomization(customization);
        });
    };

    const colorChangeToggle = toggle || (
        <Button
            icon={Button.ICON.PALETTE}
            size={Button.SIZE.SMALL}
            onClick={activateColorChangeCustomization}
            data-cy="product-edit-color-button"
            className="g-inverted"
        >
            {t('mainOverview.action.changeColor_a11y')}
        </Button>
    );
    return (
        <ProductColorChangeDropdown
            data-cy="products-color-change-dropdown"
            toggle={colorChangeToggle}
            actionButtonDataCy="product-edit-color-save-button"
            onColorSave={handleColorSave}
            colorChangeContext="details"
            trigger="productDetail"
            accountType={type}
        />
    );
};
